import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const MemberNameLink = styled(Link)`
  text-decoration: underline;
  color: ${props => props.theme.palette.grey[900]};
  word-break: break-all;
`;

export const TextWrapper = styled.span`
  word-break: break-all;
`;
